<template>
  <div class="asked-questions">
    <van-tabs
      v-model="activeTab"
      sticky
      color="#e93323"
      line-width="0.48rem"
      line-height="0.04rem"
      title-active-color="#282828"
      title-inactive-color="#999"
      @change="onTabChange"
    >
      <van-tab
        v-for="category in questionList"
        :key="category.id"
        :title="getTabTitle(category.title)"
      >
        <div class="category-content">
          <div
            class="section"
            v-for="section in category.sections"
            :key="section.id"
          >
            <div class="section-title">{{ section.title }}</div>
            <div
              class="question-item"
              v-for="(item, index) in section.items"
              :key="section.id + '-' + index"
            >
              <div
                class="question-header acea-row row-between-wrapper"
                @click="toggleQuestion(section.id, index)"
              >
                <div class="question-text">{{ item.q }}</div>
                <span
                  class="iconfont arrow"
                  :class="isActive(section.id, index) ? 'icon-xiangshang' : 'icon-xiangxia'"
                ></span>
              </div>
              <div
                class="answer"
                v-show="isActive(section.id, index)"
              >{{ item.a }}</div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <div class="bottom-space"></div>
  </div>
</template>

<script>
import { Tab, Tabs } from "vant";
import questionList from "../../data/askedQuestions";

export default {
  name: "AskedQuestions",
  components: {
    vanTab: Tab,
    vanTabs: Tabs
  },
  data() {
    return {
      questionList,
      activeTab: 0,
      activeKey: ""
    };
  },
  methods: {
    getTabTitle(title) {
      return title.replace(/^[一二三]、/, "");
    },
    onTabChange() {
      this.activeKey = "";
    },
    getQuestionKey(sectionId, index) {
      return sectionId + "-" + index;
    },
    isActive(sectionId, index) {
      return this.activeKey === this.getQuestionKey(sectionId, index);
    },
    toggleQuestion(sectionId, index) {
      const key = this.getQuestionKey(sectionId, index);
      this.activeKey = this.activeKey === key ? "" : key;
    }
  }
};
</script>

<style scoped>
.asked-questions {
  min-height: 100vh;
  background-color: #f5f5f5;
  box-sizing: border-box;
}

.category-content {
  padding: 0.2rem;
}

.section {
  background-color: #fff;
  border-radius: 0.12rem;
  margin-bottom: 0.2rem;
  overflow: hidden;
}

.section-title {
  padding: 0.24rem 0.3rem 0.12rem;
  font-size: 0.28rem;
  font-weight: 500;
  color: #666;
}

.question-item {
  border-top: 1px solid #f0f0f0;
}

.question-header {
  padding: 0.26rem 0.3rem;
}

.question-text {
  flex: 1;
  padding-right: 0.2rem;
  font-size: 0.28rem;
  color: #282828;
  line-height: 1.5;
}

.arrow {
  font-size: 0.24rem;
  color: #999;
}

.answer {
  padding: 0 0.3rem 0.28rem;
  font-size: 0.26rem;
  color: #666;
  line-height: 1.6;
  white-space: pre-line;
}

.bottom-space {
  height: 0.4rem;
}
</style>
